import { generateFetchTypes } from 'base/shared/TypeHelper';
import Types from './types';
import { fetchHomeCities, fetchBadiPlusCollection, fetchRoomCollectionsByPlaceIds } from './api';

export default {
  getHomeCities({ token, isLoggedUser, countryCode, ip, locale, userAgent }) {
    return {
      types: generateFetchTypes(Types.HOME_REQUEST),
      request: fetchHomeCities(token, isLoggedUser, countryCode, {
        ip,
        locale,
        userAgent,
      }),
    };
  },
  getBadiPlusCollection({ token }) {
    return {
      types: generateFetchTypes(Types.BADI_PLUS_COLLECTION_REQUEST),
      request: fetchBadiPlusCollection({ token }),
    };
  },
  getRoomCollectionsByPlaceIds({ token, placeIds }) {
    return {
      types: generateFetchTypes(Types.ROOM_COLLECTIONS_BY_PLACE_IDS_REQUEST),
      request: fetchRoomCollectionsByPlaceIds({ token, placeIds }),
    };
  },
};
